
// * FORMATO DE PESOS DOMINICANOS.
export const formatNumberRD = { 
    mantissa: 2, 
    currencySymbol: 'RD$ ', 
    thousandSeparated: true
};